module.exports = __webpack_public_path__ + "img/padlock.35a93d64.png";